module.exports = __webpack_public_path__ + "img/img_1.3b6803d8.png";